module.exports = __webpack_public_path__ + "static/logo-37d592601ca377ae634891973d24edd6.svg";